import React, {useEffect, useState, useCallback} from 'react'
import PropTypes from "prop-types"
import {
  errorMessage,
  getValue, isInvalid, onBlur,
  onChange
} from "./Component";
import PromiseBuilder from "../../utils/PromiseUtils";
import ApiClient from "../../api/ApiClient";
import {debounced} from "../../utils/EventUtils";

const LocationSearch = props => {
  const [inputText, setInputText] = useState("");
  const [places, setPlaces] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);

  function onFilterChange(event) {
    setInputText(event.target.value);
    debounceRequest(event.target.value);
  }

  const debounceRequest = useCallback(
    debounced((inputText) => searchPlaces(inputText), 500)
    , []);

  function handlePlaceClick(location) {
    if(typeof props.onChange !== 'undefined') {
      props.onChange(props.hasCoordinates ? location : location.name);
    }

    props.hasCoordinates ?
      setSelectedLocation(location) :
      setSelectedLocation(location.name);



    if (props.hasCoordinates) {
      setInputText(location.name);
      onChange(props, location);
      return;
    }

    setInputText(location.name);
    onChange(props, location.name);
  }

  function searchPlaces(input) {
    if (typeof input === "undefined" || input === "") {
      return;
    }

    const url = `/api/v1/map/location/${input}`

    new PromiseBuilder()
      .then(async () => ApiClient.get(url))
      .then(async (res) => {
        const foundPlaces = res.data.payload.map((feature) => {
          return {
            name: feature.name,
            coordinates: feature.coordinates,
          }
        });
        setPlaces(foundPlaces);
      })
      .catch(async (err) => {
        console.error(err);
      })
      .run();
  }

  useEffect(() => {
    let val = getValue(props);
    if (typeof val === "string") {
      setInputText(val);
    }
    else {
      setInputText(val.name ?? "");
    }
  }, [getValue(props)]);

  useEffect(() => {
    if (!inputText && selectedLocation !== null) {
      setSelectedLocation(null);
      onChange(props, null);
    }
  }, [inputText]);

  function onInputBlur() {
    onBlur(props);
  }

  return (
    <label className={"field has-float-label dropdown select loadable "}>
      <input
        value={inputText}
        type="text"
        placeholder=" "
        disabled={props.disabled}
        autoComplete="off"
        spellCheck="false"
        className={!props.skipValidation && isInvalid(props)
          ? "is-invalid input" : "input"}
        onChange={onFilterChange}
        onBlur={onInputBlur}
      />

      <span>{props.label || 'Search for location'}</span>

      <div className="error-icon fz fz-exclamation-triangle solid">
        <div className="has-tooltip danger" data-tooltip={errorMessage(props)}/>
      </div>

      <div className="dropdown-indicator right-decoration fz fz-chevron-down"/>
      {places.length > 0 &&
        <ul className="dropdown-container overflow-hidden">
          {
            places.map((place, index) =>
              <li className="place-search-item"
                  key={index}
                  data-id={index}
                  onMouseDown={() => handlePlaceClick(place)}>
                {place.name}
              </li>
            )
          }
        </ul>
      }
    </label>
  );
}

LocationSearch.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  focus: PropTypes.bool,
  isInvalid: PropTypes.bool,
  skipValidation: PropTypes.bool,
  formField: PropTypes.object,
  hasCoordinates: PropTypes.bool,
  onChange: PropTypes.func,
};

LocationSearch.defaultProps = {
  hasCoordinates: false
}

export default LocationSearch
